<template>
  <v-container class="text-center pr-0 pl-0 pt-0" fluid>
    <v-card v-if="$store.getters.userLogged && !$store.getters.userLogged.profile">
      <v-card-title title class="primary">
        <v-icon class="mr-4">mdi-account</v-icon>
        Complete seu perfil
      </v-card-title>
      <v-card-text class="pt-10 px-6">
        <v-row>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0">
            <v-file-input
              v-model="file"
              accept="image/*"
              label="Sua foto"
              :rules="fileRules"
              outlined
              show-size
              prepend-icon="mdi-camera"
            ></v-file-input>
          </v-col>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-4 pb-0">
            <v-text-field
                v-model="nascimento"
                label="Nascimento (dd/mm/aaaa)"
                prepend-icon="mdi-cake-variant"
                maxlength="10"
                type="numeric"
                v-mask="'##/##/####'"
                clearable
                outlined
              ></v-text-field>
          </v-col>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-4 pb-0">      
              <v-textarea
                v-model="frase"
                label="Frase do perfil"
                prepend-icon="mdi-lead-pencil"
                maxlength="150"
                counter=""
                clearable
                outlined
              ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="(!file || !nascimento || !frase) || file.size > fileLimit || dialogLoader" 
          x-large color="primary" class="mb-2 pt-0 pb-0" width="100%" @click="saveProfile()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>


    <div v-if="$store.getters.userLogged.profile != null">
      <v-card class="mx-auto elevation-10" tile :disabled="dialogLoader">
        
          <v-img
            width="100%"
            :src="topImageBackground"
            gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.8)"
          >
            <v-card-text class="pt-0 px-0">
              <v-row class="">
                <v-col cols="12" class="text-right pt-0">
                  <v-btn color="primary" class="elevation-2 mt-3" @click="dialogUpdatePhoto = true;">
                    <v-icon>mdi-account-edit-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row align="end" class="fill-height">
                <v-col align-self="start" class="pa-0" cols="12">
                  <v-avatar class="profile" size="164">
                    <v-img :src="$store.getters.userLogged.profile.media.url"></v-img>
                  </v-avatar>
                </v-col>
                <v-col class="py-0">
                  <v-list-item color="rgba(0, 0, 0, .4)" dark>
                    <v-list-item-content>
                      <v-list-item-title class="title">{{$store.getters.userLogged.fullName}}</v-list-item-title>
                      <v-list-item-subtitle>com a gente desde {{$store.getters.userLogged.formattedCreatedDate}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>
          </v-img>
      </v-card>

      <v-card class="mt-2">
        <v-card-text class="">
          {{$store.getters.userLogged.profile.frase}}
        </v-card-text>
      </v-card>

      <v-card class="mt-4" v-if="this.$store.getters.userLogged.profile && this.$store.getters.userLogged.profile.professor && this.$store.getters.userLogged.profile.professor.profile.media">
        <v-card-title class="primary">
          Instrutor 
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0 text-left"> 
              <v-avatar
                size="60"
                class=""
              >
                <img :src="this.$store.getters.userLogged.profile.professor.profile.media.url">
              </v-avatar>
              <span class="font-weight-black title ml-4">{{this.$store.getters.userLogged.profile.professor.fullName}}</span>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="elevation-10 mt-2" dense v-if="false">
        <v-card-subtitle class="primary lighten-3 pt-1 pb-1">Semana</v-card-subtitle>
        <v-card-text dense class="pt-0 pb-0 mt-1 mb-1">
          <v-btn class="ma-2 primary" small rounded>
            <v-icon left>mdi-bike</v-icon>234 km
          </v-btn>
          <v-btn class="ma-2 primary" small rounded>
            <v-icon left>mdi-run</v-icon>31 km
          </v-btn>
          <v-btn class="ma-2 primary" small rounded>
            <v-icon left>mdi-swim</v-icon>6.5 h
          </v-btn>
        </v-card-text>
      </v-card>

    </div>

    <div>
      <v-dialog v-model="dialogUpdatePhoto" max-width="600">
        <v-card>
          <v-card-title class="primary">
            Atualizar Imagem
          </v-card-title>
          <v-card-text class="pt-5">
            <v-file-input
              v-model="file"
              accept="image/*"
              label="Sua foto"
              :rules="fileRules"
              outlined
              show-size
              prepend-icon="mdi-camera"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
          <v-btn color="primary" text @click="dialogUpdatePhoto = false;">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogUpdatePhoto = false; savePhoto();">
            Salvar
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Aguarde...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>

import axios from 'axios';
import HOST from '../ws'
import SnackBar from "../snackbar";

export default {
  props: {
    source: String
  },
  data: () => ({

    myHost : HOST.HOST,

    file : null,
    fileRules: [
      file =>
        !file || file.size < 500000 || "A imagem deve ter no máximo 500 Kb!"
    ],
    fileLimit: 500000,
    nascimento : '',
    frase : '',
    dialogLoader : false,
    dialogUpdatePhoto : false,

    professorList : [],

    selectedProfessor : null,

    topImageBackground : require('../assets/images/profile-background.jpg')
    

    
  }),
  mounted () {
    this.reloadProfessorList();
    if(this.$store.getters.userLogged.profile != null
      && this.$store.getters.userLogged.profile.professor != null){
      this.selectedProfessor = this.$store.getters.userLogged.profile.professor;
    }
  },
  methods : {

    saveProfile() {
      let formData = new FormData();
      formData.append("nascimento", this.nascimento);
      formData.append("frase", this.frase);
      formData.append("userId", this.$store.getters.userLogged.id);
      formData.append("file", this.file);
      formData.append("originalName", this.file.name);

      this.dialogLoader = true;
      axios
        .post(this.myHost + "/profilecontroller/createprofile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.$store.state.currentToken}`
          }
        })
        .then(response => {
          this.dialogLoader = false;
          console.log(response.status);
          

          if(response.status == 200){ //salvou ok, carregamos o usuario na sessão:

            this.axios({
              method: 'post',
              url : this.myHost + '/user/userbyemail', 
              headers: {
                  'Content-Type' : 'application/json',
                  Authorization: `Bearer ${this.$store.state.currentToken}`},           
                  data : this.$store.getters.userLogged.email
            }).then((response) => {
              this.$store.commit('addUserLogged', response.data);
              this.dialogLoader = false;
            });        
            
          }
          this.dialogLoader = false;

        });
    },

    savePhoto() {
      let formData = new FormData();
      formData.append("userId", this.$store.getters.userLogged.id);
      formData.append("file", this.file);
      formData.append("originalName", this.file.name);

      this.dialogLoader = true;
      axios
        .post(this.myHost + "/profilecontroller/updatephoto", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.$store.state.currentToken}`
          }
        })
        .then(response => {
          this.dialogLoader = false;
          console.log(response.status);
          

          if(response.status == 200){ //salvou ok, carregamos o usuario na sessão:

            this.axios({
              method: 'post',
              url : this.myHost + '/user/userbyemail', 
              headers: {
                  'Content-Type' : 'application/json',
                  Authorization: `Bearer ${this.$store.state.currentToken}`},           
                  data : this.$store.getters.userLogged.email
            }).then((response) => {
              this.$store.commit('addUserLogged', response.data);
              this.dialogLoader = false;
            });        
            
          }
          this.dialogLoader = false;

        });
    },

    salvarProfessor(){

      let formData = new FormData();
      formData.append("professorId", this.selectedProfessor.id);
      formData.append("alunoId", this.$store.getters.userLogged.id);

      this.dialogLoader = true;
      axios
        .post(this.myHost + "/profilecontroller/updateprofessor", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.$store.state.currentToken}`
          }
        }).then(response => {

          console.log('salvou professor : ' + response.status);

          if(response.status == 200){
            //salvamos ok, carreagamos usuario na sessao:
            this.axios({
              method: 'post',
              url : this.myHost + '/user/userbyemail', 
              headers: {
                  'Content-Type' : 'application/json',
                  Authorization: `Bearer ${this.$store.state.currentToken}`},           
                  data : this.$store.getters.userLogged.email
            }).then((response) => {
              
              this.$store.commit('addUserLogged', response.data);
              this.dialogLoader = false;
              console.log('atualizando usuario : ' + response.status);
              this.dialog = false;
              SnackBar.snackText = "Professor atualizado";
              SnackBar.showSnack = true;
            
            });
          }
      })
      .catch((error) => {
        console.log(error.message);
        SnackBar.snackText = "Ops... ocorreu um erro. Tente novamente, por favor.";
        SnackBar.showSnack = true;
      });

    },
    reloadProfessorList(){
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/allprofessores', {}, config)
      .then(response => {
        this.professorList = response.data;
      })
      .catch((error) => {
         console.log(error.message);
         this.$store.commit('logout');
         this.$router.push("/");
      });
    }

  },
  validations: {
    file: {
      
    }
  },
};
</script>